import React, { useContext } from "react";
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Add, Back, Sync } from "../Icons/Icons";
import ProtocolContext from "../../containers/Protocols/ProtocolContext/ProtocolContext";
import { canAddToTemplate, getComponentsTypeLabelKey, isArrayFieldAllowed, templateHasSyncTo } from "./arrayFieldTemplate";

export const DynamicFormControls = (props) => {
    const { formFieldTypes, formType, targetArray, onAddFormFieldControlClick, onAddControlClick, onBackToForm } = props;
    const fieldTypes = [
        'DividerField', 'TextField', 'SingleLineField', 'MultiLineField', 'IntegerField', 'DecimalField', 'YesNoField', 'BooleanField', 'PayableField',
        'DateField', 'TimeField', 'DateTimeField', 'CheckboxField', 'MultiCheckBoxField', 'RadioField', 'SelectField', 'SelectAsyncField',
        'SnomedField', 'ProcedureSnomedField', 'FileUploadField', 'AdverseEventsAsyncField', 'UserField', 'ProtocolImpFormField', 'ProtocolConcomitantFormField', 'PharmacyFormField',
        'ArrayField'
    ].filter(type => type !== 'ArrayField' || isArrayFieldAllowed(formType));

    const context = useContext(ProtocolContext);
    if (context.isDisabled || props.isDisabled) return null;

    return (
        <div className="card">
            <div className="header">
                <h4 className="title">{i18n.t("protocols.visit.controls.title")}</h4>
            </div>
            {
                targetArray &&
                <div className="array-field-target-banner">
                    <span>{i18n.t("protocols.visit.formTemplate.arrayTargetActive", { name: i18n.t(getComponentsTypeLabelKey(targetArray.componentsType)) })}</span>
                    <button type="button" className="btn btn-sm btn-default btn-full" onClick={onBackToForm}>
                        <Back /> {i18n.t("protocols.visit.formTemplate.backToForm")}
                    </button>
                </div>
            }
            <div className="content" style={{ maxHeight: '400px', overflowY: 'scroll' }}>
                {
                    formFieldTypes?.map(function (type, index) {
                        return (<button key={`button-formTypeFields${index}`} name={type.value} type="button"
                            className="btn btn-sm btn-success btn-full btn-fill"
                            onClick={() => onAddFormFieldControlClick(type)}
                            disabled={targetArray && templateHasSyncTo(targetArray.template, type.value)}
                            style={{ marginBottom: '5px', textAlign: 'left' }}>
                            <Sync /> {i18n.t(`protocols.visit.formTemplate.formTypeFields.${type.value}`)}
                        </button>);
                    })
                }
                {
                    fieldTypes.map(function (type, index) {
                        return (<button key={`button${index}`} name={type} type="button"
                            className="btn btn-sm btn-primary btn-full btn-fill"
                            onClick={onAddControlClick}
                            disabled={targetArray && !canAddToTemplate(type)}
                            style={{ marginBottom: '5px', textAlign: 'left' }}>
                            <Add /> {i18n.t(`protocols.visit.controls.${type}`)}
                        </button>);
                    })
                }
            </div>
        </div>
    );
}

DynamicFormControls.propTypes = {
    onAddControlClick: PropTypes.func.isRequired,
    onAddFormFieldControlClick: PropTypes.func,
    onBackToForm: PropTypes.func,
    formFieldTypes: PropTypes.array,
    formType: PropTypes.string,
    targetArray: PropTypes.object
};
